// Empresas (CNPJs) com PIX habilitado no portal. Enquanto não houver um
// endpoint de configuração (como o boleto-config), a habilitação é por lista.
//
// Mesma lista também usada para o fallback de boleto via backend-virtus/
// TotalBank (DTGD-1311, BE-02): é o grupo PAX (todas as filiais) — hoje a
// única empresa que de fato usa esse fluxo. Título de empresa fora desta
// lista, sem `boleto` na carga do ERP, não tem alternativa de emissão pelo
// portal — o dado dela vem só via api-charge.
const PIX_CNPJS = [
  '03789872000179',
  '03789872000250',
  '03789872000330',
  '03789872000411',
  '03789872000500',
  '03789872000683',
  '03789872000845',
  '03789872000926',
  '03789872001060',
  '03789872001140',
  '03789872001221',
  '03789872001302',
  '03789872001493',
  '03789872001574',
  '03789872001655',
  '03789872001817',
  '03789872002031',
  '03789872002112',
  '03789872002201',
  '03789872002384',
  '03789872002546',
  '03789872002899',
];

const isInGroup = cnpj => {
  if (!cnpj) return false;
  const onlyDigits = String(cnpj).replace(/\D/g, '');
  return PIX_CNPJS.includes(onlyDigits);
};

// Retorna true se o CNPJ informado faz parte da lista de empresas com PIX.
export default function isPixEnabled(cnpj) {
  return isInGroup(cnpj);
}

// Retorna true se o CNPJ faz parte do grupo habilitado para o fallback de
// boleto via backend-virtus/TotalBank (ver comentário da lista acima).
export function isTotalBankBoletoEnabled(cnpj) {
  return isInGroup(cnpj);
}
